import { useNavigate } from "react-router-dom";

import { useHomeDataQuery } from "@/hooks/useHomeData";

import Header from "../Header";
import Icon from "../Icon";
import Loader from "../Loader";
import { Promotion } from ".";
import PromoCard from "./PromoCard";

export const CurrentUserPromotions = () => {
  const { promos: promosQuery } = useHomeDataQuery();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div
      className={
        "m-auto flex min-h-screen w-full max-w-lg flex-col justify-between px-6 pt-4"
      }
    >
      <div className={"flex flex-col"}>
        <div className={"flex flex-row justify-between"}>
          <Header className="h-8 w-80 justify-start whitespace-pre font-['Poppins'] text-2xl font-semibold leading-loose text-sky-800">
            Current Promotions
          </Header>
          <Icon name="close" onClick={goBack} />
        </div>
        <div
          className={
            "my-6 w-80 justify-center font-['Open_Sans'] text-xs font-normal leading-tight text-teal-950"
          }
        >
          Visit a Restore Studio to take advantage of these promotions today.
        </div>
        {promosQuery.isPending && <Loader />}
        {!promosQuery.isPending && (
          <div className="mb-6 flex flex-col">
            {promosQuery.data?.map((p: Promotion) => (
              <PromoCard key={p.id} promo={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
